import { render, staticRenderFns } from "./adaptiveCard.vue?vue&type=template&id=f799ca38"
import script from "./adaptiveCard.vue?vue&type=script&lang=js"
export * from "./adaptiveCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports